import {
  Box,
  Button,
  Checkbox,
  Flex,
  Grid,
  NumberInput,
  Textarea,
} from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useState } from "react";
import { repositoryDelivery } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import { modals } from "@mantine/modals";

interface UpdateDeliveryPayrollWarranty {
  asssignmentDetailId: number;
  distanceEstimated: number;
  isPayroll: boolean;
  point: number;
  note: string;
  parkingFee: number;
}

const EditDataView = ({ data, onClose }: { data: any; onClose: any }) => {
  const [dataSubmit, setDataSubmit] = useState<UpdateDeliveryPayrollWarranty>({
    asssignmentDetailId: data?.assignmentDetailId,
    distanceEstimated:
      data?.modifiedDistance === null
        ? Number(data?.distanceEstimated) / 1000
        : Number(data?.modifiedDistance) / 1000,
    isPayroll:
      data?.modifiedPayroll && data?.modifiedPayroll === "1"
        ? true
        : data?.payroll === "1"
          ? true
          : false,
    point:
      data?.modifiedPoint && Number(data?.modifiedPoint) !== 0
        ? data?.modifiedPoint
        : data?.deliveryWorkPoint,
    note: "",
    parkingFee: Number(data?.tienGuiXe) / 1000,
  });

  const handleSubmit = async () => {
    if (Number(dataSubmit.point) > 60) {
      NotificationExtension.Fails(
        "Điểm chỉ được phép sửa trong khoảng từ 0 đến 60 !",
      );
    } else {
      const res = await repositoryDelivery.post<MessageResponse<any>>(
        "/api/v1/TblDeliveryAssignment/update-delivery-payroll-for-warranty-manager",
        {
          ...dataSubmit,
          parkingFee: Number(dataSubmit?.parkingFee * 1000),
          distanceEstimated: dataSubmit.distanceEstimated * 1000,
        },
      );

      if (res && res.success) {
        NotificationExtension.Success("Cập nhật thành công !");
        setTimeout(() => {
          onClose((prev: any) => !prev);
          modals.closeAll();
        }, 1000);
      }
    }
  };

  return (
    <Box m={"5px 0px"} w={"50vw"} maw={700}>
      <Grid>
        <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
          <NumberInput
            label="Quãng đường (km)"
            placeholder="Nhập số kilomet"
            value={Number(dataSubmit?.distanceEstimated)}
            hideControls
            allowNegative={false}
            suffix=" km"
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                distanceEstimated: Number(e),
              }))
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
          <NumberInput
            label="Điểm"
            placeholder="Nhập điểm"
            value={Number(dataSubmit?.point)}
            min={-60}
            max={60}
            hideControls
            allowNegative={true}
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                point: Number(e),
              }))
            }
            error={
              Number(dataSubmit?.point) > 60 || Number(dataSubmit?.point) < -60
                ? "Điểm chỉ được phép sửa trong khoảng từ -60 đến 60"
                : undefined
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
          <NumberInput
            label="Tiền gửi xe"
            placeholder="Nhập tiền gửi xe"
            value={Number(dataSubmit?.parkingFee)}
            allowNegative={false}
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                parkingFee: Number(e),
              }))
            }
            hideControls
            thousandSeparator=" "
            suffix={
              dataSubmit?.parkingFee === 0 || !dataSubmit?.parkingFee
                ? " VNĐ"
                : " 000 VNĐ"
            }
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Textarea
            label="Ghi chú"
            placeholder="Nhập ghi chú"
            value={dataSubmit?.note}
            onChange={(e) =>
              setDataSubmit((prev) => ({
                ...prev,
                note: e.target.value,
              }))
            }
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"space-between"} align={"center"} mt={10}>
        <Checkbox
          label={"Tính lương"}
          checked={dataSubmit?.isPayroll}
          onClick={() =>
            setDataSubmit((prev) => ({
              ...prev,
              isPayroll: !dataSubmit?.isPayroll,
            }))
          }
        />
        <Button
          leftSection={<IconCheck size={14} />}
          disabled={
            Number(dataSubmit?.point) > 60 || Number(dataSubmit?.point) < -60
          }
          onClick={() => handleSubmit()}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default EditDataView;
